<template>
    <el-select ref="relationshipSelect" v-model="modelValue" @change="change" :class="className">
        <el-option v-for="item in relationships" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
import { isIE } from '@/common/useragent'

export default {
  name: 'RelationshipSelect',
  props: [
    'value',
    'relationships',
    'className'
  ],
  data () {
    return {
      modelValue: this.value
    }
  },
  mounted () {
    if (isIE()) {
      // IEでel-selectのプルダウンにフォーカスするとカーソルが表示される問題を修正
      const $input = this._$(this.$refs.relationshipSelect.$el.querySelector('input[type="text"]'))
      $input.css('pointer-events', 'none')
      $input.on('focus', event => event.currentTarget.blur())
    }
  },
  methods: {
    change: function () {
      this.$emit('input', this.modelValue)
      this.$emit('change', this.modelValue)
    }
  },
  watch: {
    value () {
      this.modelValue = this.value
    }
  }
}
</script>
